module.exports = __webpack_public_path__ + "media/images/share/ok-ac23bbc593b7f9caa957274639c1534b.svg";